// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-news-index-list-qobpw{display:grid;grid-gap:24px}.pages-news-index-list-qobpw.pages-news-index-desktop-bxfvp{grid-template-columns:repeat(4,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "pages-news-index-list-qobpw",
	"desktop": "pages-news-index-desktop-bxfvp"
};
module.exports = ___CSS_LOADER_EXPORT___;
